import { MaintanenceStateInterface } from "@app/shared/types/maintenance.interface"
import { createFeatureSelector, createSelector } from "@ngrx/store"

export const maintenaceStatusSelector = createSelector(
    createFeatureSelector('maintenance'),
    (state: MaintanenceStateInterface) => {
      return state.isMaintenance
    }
  )